import { Tooltip } from "@mui/material";
import React from "react";

const tooltip = {
  backgroundColor: "#2F2255",
  border: "1px solid rgba(168, 85, 247, 0.45)",
  boxShadow: "0 10px 30px rgba(13, 6, 31, 0.45)",
  color: "#F8F7FF",
  fontSize: "0.75rem",
  lineHeight: 1.45,
  maxWidth: 260,
  padding: "8px 10px",
};

const arrow = {
  color: "#2F2255",
  "&::before": {
    border: "1px solid rgba(168, 85, 247, 0.45)",
  },
};

const FieldTooltip = ({ children, title, placement = "top" }) => (
  <Tooltip
    arrow
    title={title}
    placement={placement}
    componentsProps={{
      tooltip: { sx: tooltip },
      arrow: { sx: arrow },
    }}
  >
    <span className="inline-flex h-4 w-4 items-center justify-center cursor-help text-white">
      {children}
    </span>
  </Tooltip>
);

export default FieldTooltip;
